import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class UsuarioModule { 
 id:string;
 usuario:string;
 clave:string;
 rol:string;
 id_local:number;
 id_pais:number;
 meail:string;
}
